import * as React from "react";
import TextField from "@mui/material/TextField";

import { Autocomplete, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import postoCombustivelApi from "../../api/postoCombustivelApi";
import { useSnack } from "../../redux/snack/snackHooks";
import { PostoCombutivel } from "../../model/entities/PostoCombustivel";

type Props = {
  setPosto: (p: PostoCombutivel | null) => void;
  posto: PostoCombutivel | null;
  label?: string;
  idPosto?: number;
};

const PostoCombustivelField: React.FC<Props> = (props) => {
  const { setPosto, label, idPosto } = props;

  const [postoSelecionado, setPostoSelecionado] =
    useState<PostoCombutivel | null>(null);
  const [postos, setPostos] = useState<PostoCombutivel[]>([]);
  const mostrarSnack = useSnack();

  useEffect(() => {
    buscarPostos();
  }, []);

  useEffect(() => {
    buscarPostos();
  }, [idPosto]);

  const buscarPostos = async () => {
    try {
      const res = await postoCombustivelApi.getManyComplete();
      setPostos(res);

      if (idPosto) {
        const postoEncontrado = res.find((item) => item.id === idPosto);
        if (postoEncontrado) {
          setPosto(postoEncontrado);
          setPostoSelecionado(postoEncontrado);
        }
      }
    } catch (erro: any) {
      mostrarSnack("Erro ao buscar lista de postos", "error");
      console.log("erro ao buscar postos", erro);
    }
  };
  const theme = useTheme();

  // Defina o valor de xs com base nos breakpoints do tema
  const xsValue = theme.breakpoints.down("sm") ? 12 : 6;
  return (
    <div style={{ textAlign: "center" }}>
      <Autocomplete
        id="filter-posto"
        options={postos}
        getOptionLabel={(option) => `${option.nome}`}
        onChange={(event, value) => {
          setPostoSelecionado(value);
          setPosto(value);
        }}
        value={postoSelecionado}
        noOptionsText={"Nenhum posto encontrado"}
        sx={{ xsValue }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant={"outlined"}
            label={label ? label : "Postos de Combustível"}
            placeholder={"PostoCombutivel"}
            multiline={true}
          />
        )}
      />
    </div>
  );
};

export default PostoCombustivelField;
